module.exports = __webpack_public_path__ + "img/shift.ea230761.svg";